var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1650953424370,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 23226,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "@font-face { font-family: feedback-iconfont; src: url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.woff2?t=1630033759944\") format(\"woff2\"), url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.woff?t=1630033759944\") format(\"woff\"), url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.ttf?t=1630033759944\") format(\"truetype\"); }\r\n"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 0C229.2224 0 0 229.239467 0 512c0 282.7776 229.239467 512 512 512 282.7776 0 512-229.239467 512-512S794.760533 0 512 0z m245.179733 478.1568l-213.333333 213.333333a42.5472 42.5472 0 0 1-30.1568 12.509867c-0.5632 0-1.092267-0.3072-1.672533-0.324267-0.5632 0.034133-1.092267 0.324267-1.672534 0.324267-10.922667 0-21.828267-4.164267-30.173866-12.509867l-213.333334-213.333333c-16.674133-16.657067-16.674133-43.6736 0-60.330667 16.674133-16.657067 43.656533-16.657067 60.330667 0L512 602.658133l184.832-184.832c16.674133-16.657067 43.6736-16.657067 60.330667 0 16.674133 16.657067 16.674133 43.6736 0.017066 60.330667z m0 0",
    "p-id": 23227
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.b4be799f78c76344cbc3d4369cb7379e.svg";
export { ForwardRef as ReactComponent };